import {
  Box,
  Card,
  CardContent,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import ScaleIcon from "@mui/icons-material/Scale";
import BloodtypeIcon from "@mui/icons-material/Bloodtype";

import Textfield from "../../shared/textfield";
//import AccessLocalStorage from "../../../services/localStorage";
import { textFieldOptional } from "../../../style2";


export default function ChildYoungPerson(props) {
  
  //const [disabledField, setDisabledField] = useState(true);
  const [disabledHeightField, setDisabledHeightField] = useState(true);
  const [disabledWeightField, setDisabledWeightField] = useState(true);
  const [disabledBloodGroupField, setDisabledBloodGroupField] = useState(true);
  const [weight, setWeight] = useState(0);
  const [blood, setBlood] = useState(0);
  //const ls = new AccessLocalStorage();
  // const handleEdit = () => {
  //   setDisabledField(!disabledField);
  //   if (!disabledField) {
  //     // To save changes here
  //   }
  // };

  // const handleCancelEdit = () => {
  //   setDisabledField(true);
  // };

  const handleWeightChange = (event) => {
    setWeight(event.target.value);
  };

  const handleBloodChange = (event) => {
    setBlood(event.target.value);
  };

  const profile = props.profile;
  
  return (
    <Box ml={2} mr={2} mb={2}>
      <Grid container sm={12} alignItems='center' justifyContent='center'>
        <Grid item xs={12} sm={3}>
          <Card>
            <CardContent align={"center"}>
              <Box display='flex' alignItems='center' justifyContent={"center"}>
                <FormatAlignRightIcon />
                <Typography variant='h5'>Height</Typography>
              </Box>
              <Box m={2} />
              {disabledHeightField ? (
                <Typography variant='body2'>{profile.user?.height ? `${profile.user?.height} cms` : "Not Known" } </Typography>
              ) : (
                <Grid container alignItems='center' justifyContent='center'>
                  <Textfield disabled={disabledHeightField} />
                  <Box m={1} />
                  <Typography variant='body2'>cm</Typography>
                </Grid>
              )}
            </CardContent>
            
            <Box m={3} />
          </Card>
        </Grid>
        <Box m={3} />
        <Grid item xs={12} sm={3}>
          <Card>
            <CardContent align={"center"}>
              <Box display='flex' alignItems='center' justifyContent={"center"}>
                <ScaleIcon />
                <Typography variant='h5' component='div'>
                  Weight
                </Typography>
              </Box>
              <Box m={2} />
              {disabledWeightField ? (
                <Typography variant='body2'>{profile.user?.weight ? `${profile.user?.weight} ${profile.user?.weightUnit?.unit}` : "Not Known"}</Typography>
              ) : (
                <Grid
                  container
                  alignItems='center'
                  justifyContent='center'
                  spacing={1}
                >
                  <Grid item>
                    <Textfield disabled={disabledWeightField} />
                  </Grid>
                  <Grid item>
                    <Select
                      value={weight}
                      onChange={handleWeightChange}
                      sx={{...textFieldOptional,
                        width: "100%",
                        padding: "3px",
                      }}
                      disabled={disabledWeightField}
                      disableUnderline
                    >
                      <MenuItem value={0}>kg</MenuItem>
                      <MenuItem value={1}>stones</MenuItem>
                    </Select>
                  </Grid>
                </Grid>
              )}
            </CardContent>
            
            <Box m={3} />
          </Card>
        </Grid>
        <Box m={3} />
        <Grid item xs={12} sm={3}>
          <Card>
            <CardContent align={"center"}>
              <Box display='flex' alignItems='center' justifyContent={"center"}>
                <BloodtypeIcon />
                <Typography variant='h5' component='div'>
                  Blood Group
                </Typography>
              </Box>
              <Box m={2} />
              {disabledBloodGroupField ? (
                <Typography variant='body2'>{profile.user?.bloodGroup}</Typography>
              ) : (
                <Select
                  value={blood}
                  onChange={handleBloodChange}
                  sx={{...textFieldOptional,
                    width: "100%",
                    padding: "3px",
                  }}
                  disabled={disabledBloodGroupField}
                  disableUnderline
                >
                  <MenuItem value={0}>Not Known</MenuItem>
                  <MenuItem value={1}>O-</MenuItem>
                  <MenuItem value={2}>O+</MenuItem>
                  <MenuItem value={3}>A-</MenuItem>
                  <MenuItem value={4}>A+</MenuItem>
                  <MenuItem value={5}>B-</MenuItem>
                  <MenuItem value={6}>B+</MenuItem>
                  <MenuItem value={7}>AB-</MenuItem>
                  <MenuItem value={8}>AB+</MenuItem>
                </Select>
              )}
            </CardContent>
            <Box m={3} />
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
